module.exports = __webpack_public_path__ + "static/quiz2_1-01bd8b9890a6b21e78fdbc26f47d6473.png";